import styled, { css } from "styled-components/native";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { black, separator_gray } from "../../StyleHelpers";

interface Props {
	type: ComponentTypeEnum;
	isNarrow?: boolean;
}

const StyledContainer = styled.View<Props>`
	height: 2px;

	${(props) => {
		switch (props.type) {
			case ComponentTypeEnum.Primary:
				return css`
					width: 100%;
					background-image: linear-gradient(to left, ${black}, #008bef 50%, ${black});
				`;
			case ComponentTypeEnum.Secondary:
				return css`
					width: 90%;
					background: ${separator_gray};
				`;
		}
	}}
`;

const StyledContainerNarrow = styled.View<Props>`
	height: 284px;
	width: 2px;

	${(props) => {
		switch (props.type) {
			case ComponentTypeEnum.Primary:
				return css`
					background-image: linear-gradient(0deg, ${black}, #008bef 50%, ${black});
				`;
			case ComponentTypeEnum.Secondary:
				return css`
					background: ${separator_gray};
				`;
		}
	}}
`;
const Separator = (props: Props) => {
	//@ts-ignore
	return props.isNarrow ? <StyledContainerNarrow type={props.type} /> : <StyledContainer type={props.type} />;
};

export default Separator;
